function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useMemo } from 'react';
import { useRefCallback, useToggle } from '@bydesign-ui/hooks';
import { classnames, guid } from '@bydesign-ui/utils';
import { usePrefixCls, useConfig } from '@byte-design/config';
import { CascaderState, useCreateCascader } from '../../hooks/tree';
import { RcClickTrigger } from '../../hooks/popper';
import { Down, Up } from '../../common/icons';
import { RcPopover } from '../../units/popover-wrapper';
import { TreePopper } from '../tree-select/components/TreePopper';
import { SelectInputWrapper } from '../util/SelectInputWrapper';
export function MultipleTreeSelectPopper(props) {
  var domRef = props.domRef,
      className = props.className,
      style = props.style,
      _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? false : _props$searchable,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? true : _props$clearable,
      _props$accordion = props.accordion,
      accordion = _props$accordion === void 0 ? false : _props$accordion,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$selectToExpand = props.selectToExpand,
      selectToExpand = _props$selectToExpand === void 0 ? false : _props$selectToExpand,
      _props$partialCheckAb = props.partialCheckAble,
      partialCheckAble = _props$partialCheckAb === void 0 ? true : _props$partialCheckAb,
      _props$showLine = props.showLine,
      showLine = _props$showLine === void 0 ? false : _props$showLine,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      popoverClassName = props.popoverClassName,
      onSelect = props.onSelect,
      onValueChange = props.onValueChange,
      spread = props.spread,
      _props$selectedIds = props.selectedIds,
      selectedIds = _props$selectedIds === void 0 ? [] : _props$selectedIds,
      placeholder = props.placeholder,
      renderItem = props.renderItem,
      datasource = props.datasource,
      onExpand = props.onExpand,
      expandedIds = props.expandedIds,
      defaultExpandedIds = props.defaultExpandedIds,
      _props$autoFocusSearc = props.autoFocusSearch,
      autoFocusSearch = _props$autoFocusSearc === void 0 ? false : _props$autoFocusSearc,
      renderSelectedName = props.renderSelectedName,
      _props$checkedStrateg = props.checkedStrategy,
      checkedStrategy = _props$checkedStrateg === void 0 ? 'parent' : _props$checkedStrateg,
      load = props.load,
      filterTreeNode = props.filterTreeNode,
      _props$autoClearSearc = props.autoClearSearchValue,
      autoClearSearchValue = _props$autoClearSearc === void 0 ? false : _props$autoClearSearc,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid;
  var handleSelect = useRefCallback(function (value) {
    onSelect && onSelect(value);
    onValueChange && onValueChange(value);
  });

  var _useCreateCascader = useCreateCascader({
    value: selectedIds,
    multiple: true,
    spread: spread,
    partialCheckAble: partialCheckAble,
    onChange: handleSelect,
    accordion: accordion,
    selectToExpand: selectToExpand,
    datasource: datasource,
    onExpand: onExpand,
    expandedIds: expandedIds,
    defaultExpandedIds: defaultExpandedIds,
    checkedStrategy: checkedStrategy,
    load: load
  }),
      cascader = _useCreateCascader.cascader;

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      show = _useToggle2[0],
      handleShow = _useToggle2[1],
      handleHide = _useToggle2[2];

  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var refPopoverId = useMemo(function () {
    return guid();
  }, []);

  var _useConfig = useConfig(),
      componentSizeMap = _useConfig.componentSizeMap;

  var handleDelete = useCallback(function (item) {
    cascader.setItemState(item.value, CascaderState.UNSELECTED);
  }, []);
  var handleClear = useCallback(function () {
    cascader.resetValue();
  }, []);
  var displayInfo = cascader.getDisplayInfo().map(function (item) {
    var id = item.id,
        label = item.label,
        disabled = item.disabled,
        readonly = item.readonly;
    return {
      label: label,
      value: id,
      disabled: disabled,
      readonly: readonly
    };
  });
  var triggerCls = usePrefixCls('multiple-tree-select-trigger');
  var cls = classnames(usePrefixCls('tree-select', {
    focus: show
  }), className);
  return React.createElement("div", {
    className: cls,
    style: style,
    ref: domRef
  }, React.createElement(RcClickTrigger, {
    triggerId: triggerId,
    disabled: disabled,
    className: triggerCls
  }, React.createElement(SelectInputWrapper, {
    icon: show ? React.createElement(Up, null) : React.createElement(Down, null),
    clearable: !disabled && clearable,
    multiple: cascader.multiple,
    datasource: displayInfo,
    popperInput: show,
    onCloseItem: handleDelete,
    placeholder: placeholder,
    renderSelectedName: renderSelectedName,
    size: size,
    disabled: disabled,
    onClear: handleClear,
    invalid: invalid
  })), React.createElement(RcPopover, {
    show: show,
    getPopper: function getPopper() {
      return React.createElement("div", {
        style: {
          height: componentSizeMap.md.height
        }
      });
    },
    arrow: false,
    placement: placement,
    offset: {
      x: 0,
      y: -componentSizeMap.md.height
    },
    onShow: handleShow,
    onHide: handleHide,
    triggerIds: triggerIds,
    popoverId: refPopoverId,
    refType: "trigger",
    refId: triggerId,
    scaleAnimation: false,
    preventOverflow: false
  }), React.createElement(RcPopover, {
    show: show,
    popoverClassName: popoverClassName,
    getPopper: React.createElement(TreePopper, {
      multiple: true,
      triggerId: triggerId,
      cascader: cascader,
      renderItem: renderItem,
      searchable: searchable,
      filterTreeNode: filterTreeNode,
      showLine: showLine,
      disabled: disabled,
      autoFocusSearch: autoFocusSearch,
      autoClearSearchValue: autoClearSearchValue,
      show: show
    }),
    offset: {
      x: 0,
      y: 4
    },
    arrow: false,
    placement: placement,
    triggerIds: triggerIds,
    onShow: handleShow,
    onHide: handleHide,
    refType: "popover",
    refId: refPopoverId,
    scaleAnimation: "y",
    unionPopoverIds: [refPopoverId]
  }));
}